import { Fragment } from "react";
import { useSelector } from "react-redux";
import { translate } from "react-switch-lang";
import { Col, Row } from "reactstrap";
import AboutSectionImage from "../../../assets/images/training-path/accueil-footer.jpg";
import { RootState } from "../../../store";
import styles from "./about-section.module.scss";

const AboutSection: React.FC<{ t: any }> = ({ t }) => {
  const currentLang = useSelector((state : RootState) => state.language.currentLang);

  const redirectContactUs = () => {
    const win = window.open(currentLang === "fr" ?  "https://www.agrisud.org/web/contact/" : "https://www.agrisud.org/web/en/contact", "_blank");
    win.focus();
  };

  return (
    <Fragment>
      <Row>
        <Col md={12}>
          <div className={styles["homepage-about-background"]}>
            <img src={AboutSectionImage} alt="" className={styles["homepage-about-image"]} />
            <div className={styles["homepage-about"]}>
              <div className={styles["homepage-about-title-wrapper"]}>
                <h5 className={styles["homepage-about-title"]}>{t("about.about_agrisud")}</h5>
              </div>
              <div className={styles["homepage-about-details"]}>
                <p className={styles["event_desc"]}>{t("about.first_sentence")}</p>
                <p className={styles["event_desc"]}>{t("about.second_sentence")}</p>
              </div>
            </div>

            <div className={styles["homepage-contact"]}>
              <div className={styles["homepage-contact-title-wrapper"]}>
                <h5 className={styles["homepage-contact-title"]}>{t("about.head_office")}</h5>
              </div>
              <div className={styles["homepage-contact-details"]}>
                <p>
                  7, avenue du Maréchal Foch
                  <br />
                  33500 Libourne - FRANCE
                </p>
                Tel : +33 (0)5 57 25 17 06
                <h6 onClick={redirectContactUs} className={styles["contact"] + " m-t-5"}>
                  {t("about.contuct_us")}
                </h6>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

export default translate(AboutSection);
